<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Destinations') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="formData.destination_cities"
                label="Cities"
                outlined
                item-text="name"
                return-object
                dense
                multiple
                :hide-details="true"
                :items="destinationCities"
                @change="updateForm"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-for="(city, key) in formData.destination_cities"
              :key="key"
              cols="12"
              sm="6"
              md="4"
            >
              <gallery
                :button-text="city.name"
                folder="booking-engine"
                :compress="false"
                :cols="6"
                :thumbnails="true"
                :images="city.image ? [city.image] : []"
                :on-change="imgs => afterCityUpload(imgs, city.name, key)"
                :uploadable="true"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Gallery from 'components/common/gallery.vue'

export default {
  name: 'Destinations',

  components: {
    Gallery,
  },

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        destination_cities: this.bookingEngineSetting.destination_cities || [],
      },
    }
  },

  computed: {
    ...mapGetters(['listingCities']),

    destinationCities() {
      return this.listingCities.map(city => ({ name: city, image: null }))
    },
  },

  methods: {
    updateForm() {
      this.$emit('update:setting', this.formData)
    },

    afterCityUpload(imgs, name, key) {
      this.formData.destination_cities[key] = {
        name,
        image: imgs[0],
      }
      this.$forceUpdate()
      this.updateForm()
    },
  },
}
</script>
